<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_bank"
        title="Bankdaten"
        @save="saveFirmBankAccount">
        <b-row v-if="showChangelogButton">
            <div class="col d-flex justify-content-end">
                <csp-changelog-modal :changelog-url="firmBankAccountChangelogUrl"/>
            </div>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Kontoinhaber"
                property="depositor"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="IBAN"
                property="iban"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="BIC"
                property="bic"
                type="bankbicinput"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Bankname"
                property="bankName"
                type="text"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="PLZ der Bank"
                property="postalCode"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Ort der Bank"
                property="place"
                type="text"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Einzugsermächtigung erteilt"
                property="hasBankCollection"
                type="checkbox"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmBankAccount',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
            firmBankAccountChangelogUrl() {
                return '/api/desktop/firms/' + this.firmId + '/bank-account/changelog';
            },
            showChangelogButton() {
                return this.formContext.data.isEntityNew === false
                    && !this.formContext.isInEditMode
                    && this.formContext.permissions.showChangelog === true;
            },
        },
        methods: {
            saveFirmBankAccount(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmBankAccount(this.firmId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
